<template>
  <img
    :src="apiImage ?
      `${filename}` :
      require(`@/assets/img/${filename}`)"
    :alt="alt"
    :title="thetitle"
    />
</template>

<script>
export default {
  name: 'logo',
  props: {
    filename: {
      type: String,
      default: 'zerocoma.png'
    },
    alt: {
      type: String,
      default: 'EdasInvoiZE'
    },
    title: {
      type: String,
      default: null
    },
    apiImage: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
    }
  },
  computed: {
    thetitle: function () {
      return this.title ? this.title : this.alt
    }
    
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>
